import React from 'react';
import { LoadingComponent } from '../General/LoadingComponent';
import { useEmployeesPageContext } from './contexts/EmployeesPageContext';
import { DateTime } from 'luxon';
import { useSelector } from 'react-redux';
import { DataTable } from '@/library/DataTable';
import { ColumnDef } from '@tanstack/react-table';
import { ActionsMenu } from '@/library/ActionMenu';
import { Invitation } from '@/types/Invitation/Invitation';
import { useCrudPageStateContext } from '@/context/CrudPageContext';
import { useTranslation } from 'react-i18next';

function EmployeesInvitesTable() {
  const { t } = useTranslation();
  const { invites, invitesIsLoading, setOpenDeleteInvitationDialog } = useEmployeesPageContext();
  const { setEntityToDelete } = useCrudPageStateContext();
  const selectedAffiliate = useSelector((state: any) => state.affiliate.selectedAffiliate);
  const isAdmin = selectedAffiliate.isAdmin;
  const hasInvites = invites.length > 0;

  const columns: ColumnDef<Invitation>[] = [
    {
      accessorKey: 'name',
      header: t('general.table_headers.name'),
      cell: ({ row }) => <div>{row.getValue('name')}</div>,
    },
    {
      accessorKey: 'email',
      header: t('general.table_headers.mail'),
      cell: ({ row }) => <div>{row.getValue('email')}</div>,
    },
    {
      accessorKey: 'expiration_date',
      header: t('general.table_headers.expiration_date'),
      cell: ({ row }) => (
        <div>{DateTime.fromISO(row.original.expiration_date).toFormat('dd.LL.y')}</div>
      ),
    },
    {
      id: 'actions',
      cell: ({ row }) => (
        <ActionsMenu
          isAdmin={isAdmin}
          entity={row.original}
          actions={[
            {
              label: t('general.table_actions.copy'),
              onClick: () => {
                navigator.clipboard.writeText(
                  window.location.protocol +
                    '//' +
                    window.location.host +
                    '/auth/join-affiliate/' +
                    row.original.token,
                );
              },
            },
            {
              label: t('general.table_actions.delete'),
              onClick: () => {
                setEntityToDelete(row.original);
                setOpenDeleteInvitationDialog(true);
              },
            },
          ]}
        />
      ),
    },
  ];

  return (
    <div>
      {invitesIsLoading ? (
        <LoadingComponent paddingTop={true} />
      ) : hasInvites || isAdmin ? (
        <>
          <h1 className="px-6 mt-6 mb-2 text-lg">{t('employee_page.invitations')}</h1>
          <DataTable
            disableColumnSelector={true}
            disableSearch
            data={Object.values(invites)}
            columns={columns}
          />
        </>
      ) : null}
    </div>
  );
}

export { EmployeesInvitesTable };
